<template>
  <base-section
    id="price"
    title="料金プラン"
    subtitle="初期費用0円、時間単位でご利用いただけます"
    background="light"
  >
    <div class="price-section">
      <div class="price-table">
        <table class="price-table__content">
          <thead>
            <tr>
              <th>ご利用時間</th>
              <th>料金（税込）</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1時間</td>
              <td class="price">¥1,440</td>
            </tr>
            <tr>
              <td>2時間</td>
              <td class="price">¥2,880</td>
            </tr>
            <tr>
              <td>3時間</td>
              <td class="price">¥4,320</td>
            </tr>
            <tr>
              <td>4時間</td>
              <td class="price">¥5,760</td>
            </tr>
          </tbody>
        </table>
        
        <div class="price-notes">
          <h5>ご利用にあたって</h5>
          <ul>
            <li>初回見学は無料です</li>
            <li>ご予約は2時間から承ります</li>
            <li>延長は15分単位で可能です<br />（※最低利用時間2時間から。15分¥360）</li>
            <li>キャンセル料金は7日前から発生します</li>
          </ul>
        </div>
      </div>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';

export default {
  name: 'PriceSection',
  components: {
    BaseSection
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.price-section {
  max-width: 800px;
  margin: 0 auto;
}

.price-table {
  &__content {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: $spacing-2xl;
    box-shadow: $shadow-sm;
    border-radius: $radius-lg;
    overflow: hidden;
    
    th {
      background-color: $primary-color;
      color: $white;
      padding: $spacing-lg;
      text-align: left;
      font-weight: 600;
      font-size: $font-size-lg;
    }
    
    td {
      padding: $spacing-lg;
      border-bottom: 1px solid $gray-200;
      background-color: $white;
      
      &.price {
        font-size: $font-size-xl;
        font-weight: 600;
        color: $primary-color;
        text-align: right;
      }
    }
    
    tr:last-child td {
      border-bottom: none;
    }
    
    tr:hover td {
      background-color: $gray-100;
    }
  }
}

.price-notes {
  background-color: $white;
  padding: $spacing-xl;
  border-radius: $radius-lg;
  box-shadow: $shadow-sm;
  
  h5 {
    font-size: $font-size-xl;
    color: $primary-color;
    margin-bottom: $spacing-lg;
  }
  
  ul {
    margin: 0;
    padding-left: $spacing-xl;
    
    li {
      margin-bottom: $spacing-md;
      color: $gray-700;
      line-height: 1.6;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@include media-breakpoint-down(sm) {
  .price-table {
    &__content {
      font-size: $font-size-sm;
      
      th, td {
        padding: $spacing-md;
      }
      
      td.price {
        font-size: $font-size-lg;
      }
    }
  }
  
  .price-notes {
    padding: $spacing-lg;
  }
}
</style>